import type {InterfaceStrings} from './strings'

export const hi: InterfaceStrings = {
    nav: {
        beginSession: 'शुरू करें',
        faq: 'सवाल-जवाब',
        pricing: 'कीमतें',
        legal: 'कानूनी जानकारी',
        signIn: 'साइन इन करें',
        viewPricing: 'कीमतें देखें',
        signOut: 'साइन आउट करें',
        account: 'खाता',
        menu: 'मेन्यू',
        closeMenu: 'मेन्यू बंद करें',
        mainNav: 'मुख्य नेविगेशन',
        sessions: {one: '{n} सत्र', other: '{n} सत्र'},
    },
    footer: {
        selfHypnosisFor: 'आत्म-सम्मोहन',
        anxiety: 'चिंता के लिए',
        sleep: 'नींद के लिए',
        stress: 'तनाव के लिए',
        confidence: 'आत्मविश्वास के लिए',
        focus: 'एकाग्रता के लिए',
        learn: 'पद्धति',
        ericksonian: 'एरिक्सोनियन सम्मोहन क्या है',
        aiHow: 'AI सम्मोहन कैसे काम करता है',
        vsMeditation: 'सम्मोहन या ध्यान',
        methods: 'अभ्यास',
        languages: 'भाषाएँ',
    },
    page: {
        cta: 'अपना मुफ़्त सत्र शुरू करें',
        hint: 'आपका पहला सत्र मुफ़्त है',
        exploreFurther: 'और पढ़ें',
        disclaimer:
            'Quies विश्राम और आत्म-खोज के लिए एक वेलनेस साधन है। यह कोई चिकित्सा उपकरण नहीं है और किसी भी रोग का निदान, उपचार या इलाज नहीं करता। अगर आप किसी मानसिक संकट से गुज़र रहे हैं, तो किसी योग्य विशेषज्ञ से संपर्क करें।',
        transcript: 'पाठ',
        transcriptNote: 'Quies के एक असली सत्र का अंश, जैसा वह बोला गया था।',
        breadcrumb: 'नेविगेशन पथ',
    },
    pricing: {
        selectPlan: 'यह पैक चुनें',
        subscribe: 'सदस्यता लें',
        perMonth: 'प्रति माह',
        manageSubscription: 'सदस्यता प्रबंधित करें',
        replayFree: 'पिछले सत्र को दोबारा सुनना हमेशा मुफ़्त है।',
        offerLead: 'हर सत्र वहीं से शुरू होता है जहाँ पिछला सत्र समाप्त हुआ था।',
    },
    session: {
        chooseLanguage: 'अपनी भाषा चुनें',
        changeLanguage: 'भाषा बदलें',
        changeVoice: 'आवाज़ बदलें',
        previewVoice: '{voice} की आवाज़ सुनें',
        stopPreview: 'नमूना रोकें',
        continue: 'आगे बढ़ें',
        composing: 'Quies आपका सत्र लिख रहा है',
        preparing: 'आपका ध्यान तैयार हो रहा है',
        pickingUp: 'जहाँ आपने छोड़ा था, वहीं से',
        today: 'आज',
        yesterday: 'कल',
        loading: 'लोड हो रहा है…',
        showEarlier: 'पिछले दिखाएँ ({count})',
        tryDifferentApproach: 'कोई दूसरा रास्ता आज़माएँ',
        nothingAdded: 'कुछ नहीं जोड़ा',
        purchaseConfirmed: 'ख़रीद की पुष्टि हो गई',
        firstSessionNote: 'आपका पहला सत्र मुफ़्त है। सुनने से पहले आपको साइन इन करना होगा।',
    },
    threshold: {
        title: 'सुनने के लिए साइन इन करें',
        message: 'आपका पहला सत्र मुफ़्त है। कार्ड की ज़रूरत नहीं।',
        google: 'Google से जारी रखें',
        sendLink: 'मुझे साइन-इन लिंक भेजें',
        sending: 'भेजा जा रहा है…',
        emailLabel: 'ईमेल पता',
        or: 'या',
        waitingTitle: 'अपना ईमेल देखें',
        waitingBody: 'हमने {email} पर साइन-इन लिंक भेजा है।',
        sendAgain: 'फिर से भेजें',
        googleInstead: 'इसके बजाय Google से साइन इन करें',
        codeLabel: 'या ईमेल में मिला 6 अंकों का कोड लिखें',
        codeSubmit: 'आगे बढ़ें',
        codeSubmitting: 'जाँच हो रही है…',
        codeWrong: 'यह कोड सही नहीं है।',
        codeDead: 'यह कोड अब काम नहीं करता। ईमेल में दिया गया लिंक इस्तेमाल करें, या नया भेजें।',
        errors: {
            invalidEmail: 'सही ईमेल पता लिखें।',
            rateLimited: 'बहुत ज़्यादा कोशिशें हो गईं। कुछ मिनट बाद फिर कोशिश करें।',
            sessionError: 'आपके साइन-इन में कुछ गड़बड़ हो गई। पेज रीफ़्रेश करके फिर कोशिश करें।',
            sendFailed: 'ईमेल भेजा नहीं जा सका। फिर कोशिश करें।',
            sessionExpired: 'आपका साइन-इन समाप्त हो गया। पेज रीफ़्रेश करके फिर कोशिश करें।',
            generic: 'कुछ गड़बड़ हो गई। फिर कोशिश करें।',
        },
    },
    player: {
        play: 'चलाएँ',
        pause: 'रोकें',
        playAgain: 'फिर से सुनें',
        seek: 'स्थान',
        eyesClosed: 'आँखें बंद',
        openEyes: 'आँखें खोलें',
        paused: 'रुका हुआ',
        unavailable: 'ऑडियो उपलब्ध नहीं',
        untitled: 'Quies सत्र',
    },
    failure: {
        turnFailed: 'हमारी ओर से कुछ गड़बड़ हो गई। आपका जवाब सुरक्षित है।',
        reconnecting: 'फिर से जुड़ रहे हैं…',
        refusalTitle: 'चलिए, कोई दूसरा रास्ता लेते हैं',
        refusal: 'आपके संदेश के एक हिस्से का जवाब नहीं दिया जा सका। इसे दूसरे शब्दों में कहें, या फिर से भेजें।',
        openElsewhere: 'यह सत्र किसी दूसरी विंडो में भी खुला है।',
        serviceDown: 'अभी Quies तक पहुँचा नहीं जा सकता। आपका किया हुआ कुछ भी खोया नहीं है।',
        sessionsUsedTitle: 'आपके सत्र इस्तेमाल हो चुके हैं',
        voiceFailedTitle: 'आपका ध्यान लिखा जा चुका है',
        voiceFailed: 'अभी इसकी आवाज़ नहीं बन पाई। कुछ भी खोया नहीं है, और दोबारा आवाज़ देने का कोई शुल्क नहीं है।',
        voiceStopped: 'आवाज़ बीच में रुक गई। वह वहीं से आगे बढ़ सकती है जहाँ रुकी थी।',
        streamMissing: 'आपका ध्यान तैयार है, पर यह इस पेज तक नहीं पहुँचा।',
        tapToListen: 'सुनने के लिए छुएँ',
        fileFailed: 'यह रिकॉर्डिंग नहीं चल रही। ध्यान को बिना शुल्क दोबारा आवाज़ दी जा सकती है।',
        recordingGone: 'यह रिकॉर्डिंग अब सहेजी नहीं जाती।',
        purchaseCancelled: 'ख़रीद रद्द हुई। कोई राशि नहीं ली गई।',
        purchasePending: 'आपके भुगतान की पुष्टि हो गई है। आपके सत्र आने में सामान्य से ज़्यादा समय लग रहा है।',
        checkoutFailed: 'भुगतान पूरा नहीं हो सका। कोई राशि नहीं ली गई।',
        sessionEnded: 'यह सत्र पूरा हो गया है।',
        busy: 'अभी Quies पर बहुत माँग है। आपका जवाब सुरक्षित है; एक मिनट बाद फिर कोशिश करें।',
        tooLong: 'यह सत्र इतना लंबा हो गया है कि Quies इसे सँभाल नहीं सकता। यह आपको लौटा दिया गया है।',
        notSaved: 'यह क़दम सहेजा नहीं जा सका। यहीं से आगे बढ़ने के लिए फिर कोशिश करें।',
        meditationRefused:
            'यह ध्यान माँगे गए ढंग से नहीं लिखा जा सका। इसे दूसरे शब्दों में कहें, या नए सिरे से शुरू करें: यह सत्र आपको लौटा दिया जाएगा।',
        meditationRefusedUncharged:
            'यह ध्यान माँगे गए ढंग से नहीं लिखा जा सका। इसे दूसरे शब्दों में कहें, या नए सिरे से शुरू करें।',
        linkExpired: 'आपके साइन-इन लिंक की अवधि ख़त्म हो गई है। नया लिंक माँगें।',
        oauthFailed: 'साइन इन बीच में रुक गया। कृपया फिर कोशिश करें।',
        offline: 'आप ऑफ़लाइन हैं। कनेक्शन लौटते ही आपका जवाब भेज दिया जाएगा।',
        voiceChanged: 'आपकी चुनी हुई आवाज़ अब उपलब्ध नहीं है; यह ध्यान कोई दूसरी आवाज़ पढ़ेगी।',
        voiceReturned: 'आवाज़ अब भी नहीं बन पाई। यह सत्र आपको लौटा दिया गया है।',
        voiceFailedAgain: 'आवाज़ अब भी नहीं बन पाई।',
        voiceResuming: 'आवाज़ फिर से शुरू हो रही है…',
        voiceLimited: 'इस घंटे में आपके लिए कई ध्यान आवाज़ में तैयार हो चुके हैं। थोड़ी देर बाद फिर कोशिश करें।',
        tryAgain: 'फिर कोशिश करें',
        rephrase: 'दूसरे शब्दों में कहें',
        resume: 'फिर शुरू करें',
        voiceAgain: 'दोबारा आवाज़ दें',
        listen: 'सुनें',
        continue: 'आगे बढ़ें',
        begin: 'सत्र शुरू करें',
        signIn: 'साइन इन करें',
        checkAgain: 'फिर जाँचें',
        sendLink: 'साइन-इन लिंक भेजें',
        useEmail: 'ईमेल से जारी रखें',
    },
}
